(function() {

	'use strict';
		
	window.injectCurrentTimeSynchrotron = (function(){

		function injectCurrentTimeSynchrotron( audioElement, offset_ms, stime_ms, ignore_sync ) {

			console.log( "injectCurrentTimeSynchrotron()", arguments );
			
			if (audioElement.$$synchrotronActive) {

				console.debug( "injectCurrentTimeSynchrotron() :: Cleaning old synchrotron" );

				removeSynchrotron( audioElement );
			}

			offset_ms   = offset_ms || 0;
			stime_ms    = stime_ms  || Date.now();
			ignore_sync = !!ignore_sync;

			audioElement.$$getCurrentTime = function() {
				return (Date.now() - stime_ms + offset_ms) / 1000;
			};

			console.log( "injectCurrentTimeSynchrotron() :: offset_ms:",    offset_ms );
			console.log( "injectCurrentTimeSynchrotron() :: stime_ms:",     stime_ms );
			console.log( "injectCurrentTimeSynchrotron() :: ignore_sync:",  ignore_sync );
			console.log( "injectCurrentTimeSynchrotron() :: audioElement:", audioElement );

			audioElement.$$synchrotron_fn = function $$refreshAudioElementCurrentTime() {

				if (audioElement.paused || !audioElement.duration || audioElement.muted) {
					console.warn( "injectCurrentTimeSynchrotron.$$refreshAudioElementCurrentTime() :: audio is not playing or is muted or have no length! Aborted." );
					return;
				}

				console.debug( "injectCurrentTimeSynchrotron.$$refreshAudioElementCurrentTime()" );

				var t0 = audioElement.$$getCurrentTime(); // (Date.now() - stime_ms + offset_ms);
				var tc = audioElement.currentTime; //  * 1000;
				var dtime = tc - t0;

				if (t0 < 0) {

					console.warn( "injectCurrentTimeSynchrotron.$$refreshAudioElementCurrentTime() :: audio.$$getCurrentTime() < 0!" );

				} else if (Math.abs( dtime ) <= injectCurrentTimeSynchrotron.dTime_Tolerance) {

					console.debug( "injectCurrentTimeSynchrotron.$$refreshAudioElementCurrentTime() :: dtime(s): ", dtime );

				} else {

					console.warn( "injectCurrentTimeSynchrotron.$$refreshAudioElementCurrentTime() :: dtime(s): ", dtime );

					if (!ignore_sync) {
						if (window.DEV) try {
							angular.element(document.body).injector().get("Notification").info({ message: "AE::Sync(dtime=" + dtime + "s)", delay: 2500 })
						} catch(e) { }

						audioElement.currentTime = audioElement.$$getCurrentTime(); // (Date.now() - stime_ms + offset_ms) / 1000;
					}
				}
			}

			audioElement.$$synchrotronActive = true;
	/*
			if (!audioElement.$$synchrotron_fn.interval_loop) {
				audioElement.$$synchrotron_fn.interval_loop = function() {
					console.count( "audioElement.$$synchrotron_fn.interval_loop()" );
					if (audioElement.paused || audioElement.muted) return;
					audioElement.$$synchrotron_fn();
				}
			}
	*/
			audioElement.removeEventListener( 'loadstart',      $$handleAudioElementEvent );
			audioElement.removeEventListener( 'progress',       $$handleAudioElementEvent );
			audioElement.removeEventListener( 'canplay',        $$handleAudioElementEvent );
			audioElement.removeEventListener( 'canplaythrough', $$handleAudioElementEvent );
			audioElement.removeEventListener( 'play',           $$handleAudioElementEvent );

			if (true) {
				init_$$handleAudioElementEvent.call( audioElement );
			} else {
				audioElement.removeEventListener( 'durationchange', init_$$handleAudioElementEvent );
				audioElement.addEventListener(    'durationchange', init_$$handleAudioElementEvent );
			}
		}

		injectCurrentTimeSynchrotron.$$handleAudioElementEvent = $$handleAudioElementEvent;

		injectCurrentTimeSynchrotron.removeSynchrotron = removeSynchrotron;

		injectCurrentTimeSynchrotron.dTime_Tolerance = 0.1; // sekuntia

		return injectCurrentTimeSynchrotron;

		function removeSynchrotron( audioElement ) {
			
			if (!audioElement.$$synchrotronActive) return;

			/** @TODO Missä alustetaan? */
			audioElement.removeEventListener( 'durationchange', init_$$handleAudioElementEvent );

			audioElement.removeEventListener( 'loadstart',      $$handleAudioElementEvent );
			audioElement.removeEventListener( 'progress',       $$handleAudioElementEvent );
			audioElement.removeEventListener( 'canplay',        $$handleAudioElementEvent );
			audioElement.removeEventListener( 'canplaythrough', $$handleAudioElementEvent );
			audioElement.removeEventListener( 'play',           $$handleAudioElementEvent );

			audioElement.$$synchrotron_fn = dummySynchrotronFn;
			audioElement.$$getCurrentTime = dummyGetCurrentTime;
			
			audioElement.$$synchrotronActive = false;
		}

		function dummySynchrotronFn() {
			console.debug( "dummy synchrotron_fn()!!" );
		}
			
		function dummyGetCurrentTime() {
			console.debug( "dummy synchrotron_fn()!!" );
		}

		function init_$$handleAudioElementEvent() {

			/** @TODO Missä alustetaan? */
			this.removeEventListener( 'durationchange', init_$$handleAudioElementEvent );

			this.addEventListener(    'loadstart',      $$handleAudioElementEvent );
			this.addEventListener(    'progress',       $$handleAudioElementEvent );
			this.addEventListener(    'canplay',        $$handleAudioElementEvent );
			this.addEventListener(    'canplaythrough', $$handleAudioElementEvent );
			this.addEventListener(    'play',           $$handleAudioElementEvent );
		}

		function $$handleAudioElementEvent( event ) {
			if (this.paused || this.muted) return;

			if (window.DEV) try {
				//angular.element(document.body).injector().get("Notification").info({ message: "AE::Event(type="+event.type+")", delay: 2500 })
			} catch(e) { }

			console.debug( "injectCurrentTimeSynchrotron.$$handleAudioElementEvent()", event.type||event );
			this.$$synchrotron_fn();
		}
	})();
})();
